<template>
  <div>
    <div class="">
      <div
        class="upload-box"
        v-if="pageType !== 'view' && pageType !== 'review'"
      >
        <input class="upload-image" type="file" @change="uploadFile" />
        <i class="el-icon-picture-outline">Upload</i>
      </div>
      <div class="img-box">
        <el-image
          class="is-img"
          v-loading="imgLoading"
          :src="bannerUrlVal"
          @load="loadImg"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
import {
  uploadFilmMasterPoster
} from '@/api/film-material-management/filmMaster'
export default {
  props: {
    bannerPath: {
      type: String,
      default: '',
    },
    pageType: {
      type: String,
      default: '',
    },
    bannerUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imgLoading: false,
    }
  },
  computed: {
    bannerUrlVal: {
      get() {
        return this.bannerUrl
      },
      set(val) {
        this.$emit('update:bannerUrl', val)
      },
    },
    bannerPathVal: {
      get() {
        return this.bannerPath
      },
      set(val) {
        this.$emit('update:bannerPath', val)
      }
    }
  },
  methods: {
    formatDateTimeFull(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}${month}${day}_${hours}_${minutes}_${seconds}`
    },

    loadImg() {
      this.imgLoading = false
    },
    uploadFile(event) {
      this.imgLoading = true
      const file = event.target.files[0]
      const master_id = this.$route.query.id ? this.$route.query.id : this.formatDateTimeFull(new Date())

      if (file) {
        const formData = new FormData()
        // 将文件附加到 formData 的 'file' 字段
        formData.append('file', file)
        uploadFilmMasterPoster(master_id, formData).then(res => {
          this.bannerPathVal = res.data.path
          this.bannerUrlVal = res.data.url
        }).catch(() => {
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-box {
  position: relative;
  width: 130px;
  height: 40px;

  .upload-image {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    opacity: 0;
    cursor: pointer;
  }
  .el-icon-picture-outline {
    padding: 5px;
    position: absolute;
    font-size: 20px;
    cursor: pointer;
    z-index: 1;
    top: 0;
    left: 0;
    border-radius: 5px;
    border: 1px solid #cbcbcb;
  }
}
.img-box {
  width: 80%;
  height: 250px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  // overflow: hidden;
  .is-img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
    // object-position: center;
  }
}
</style>
